<template>
  <div>
    <v-img
      :src="require('@/assets/landingpage_bg.jpg')"
      height="500"
    >
      <v-row
        align="center"
        justify="center"
        class="landingpage-image-shader"
      >
        <v-col
          class="text-center head-area landing-page-title-offset"
          cols="12"
        >
          <h1 class="display-text-large primary--text mb-2">
            communitree
          </h1>
          <div class="font-weight-bold mb-4 mx-8">{{$t('pageTagline')}}</div>
          <v-btn
            color="primary"
            rounded
            dark
            class="mt-4 mb-16"
            @click="scrollToClass('.summary-area')"
          >{{$t('findOutMore')}}</v-btn>
        </v-col>
      </v-row>
    </v-img>

    <v-container class="landing">

      <!--<v-row
        class="summary-area pt-16"
        align="center"
        justify="center">
          <v-col
            class="text-center head-area landing-page-title-offset"
            cols="12"
          >
            <h1 class="display-3 grey--text mb-2">
              We believe raising trees together is good for nature and well-being.
            </h1>
          </v-col>
      </v-row>-->

      <div class="mt-16"/>

      <ImageWithText
        class="how-it-works-area"
        title="How it works"
        titleStyle="white--text display-text-large"
        :height="180"
        :image="require('@/assets/seed.jpg')"/>
      <StepperItem step="1" color="grey darken-4 white--text">
        <p>{{$t('step1')}}</p>
        <SignUpButton/>
      </StepperItem>

      <StepperItem step="2" color="grey darken-4 white--text">
        <p>{{$t('step2')}}</p>
      </StepperItem>

      <StepperItem step="3" color="grey darken-4 white--text">
        <p>{{$t('step3')}}</p>
      </StepperItem>

      <StepperItem step="4" color="grey darken-4 white--text">
        <p>{{$t('step4')}}</p>
      </StepperItem>

      <v-row
        class="summary-area pt-16"
        align="center"
        justify="center">
          <v-col
          >
            <h3>{{$t('explanationTitle')}}</h3>
            <p>
              {{$t('explanationTextP1')}}
            </p>
            <p>
              {{$t('explanationTextP2')}}
            </p>
            <p>
              {{$t('explanationTextP3')}}
            </p>
            <SignUpButton/>
          </v-col>
      </v-row>

      <div class="mt-16"/>

      <TextImageRow :title="$t('connectionTitle')"
        :text="$t('connectionText')"
        :image="require('@/assets/create_chests.jpg')"/>

      <TextImageRow :title="$t('inclusionTitle')"
        :text="$t('inclusionText')"
        :image="require('@/assets/inclusion2.jpg')"
        :left="true"/>

      <TextImageRow :title="$t('greenTitle')"
        :text="$t('greenText')"
        :image="require('@/assets/green_city.jpg')"/>

      <v-row
        class="mt-16 cities-area"
        align="center"
        justify="center">
          <v-col
            class="text-center"
          >
            <h6  class="display-text-large">{{$t('ourCities')}}</h6>
          </v-col>
      </v-row>

      <ImageWithText title="Bolzano(Don Bosco)" :height="400" :image="require('@/assets/bolzano.jpg')"/>

      <v-row
        class="mt-16 new-city-area"
        align="start"
        justify="start">
          <v-col
            class="text-center"
          >
            <h6  class="display-text-large">{{$t('newCityTitle')}}</h6>
            <p>Do you want communitree in your city, too? Cool, we want to hear from you! Send us a few lines at init.giorgio@gmail.com about who you are and where you are from. We can give you easy instructions on how to set up the project in your own city, and we help you with out experience to make commnitree also happen in your city. :)</p>
          </v-col>
      </v-row>

      <v-row
        class="mt-0"
        align="center"
        justify="center"
        dark>

        <v-col
          class="text-center"
          cols="9"
        >
          <div class="blue--text font-weight-regular">
            Hey there, communitree is currently starting up in Bozen (Italy).
            We are still working on it, but if you have any wishes, feedback, ideas drop us a line at hi.communitree@gmail.com.
            Thank you for being here &lt;3
          </div>
        </v-col>
      </v-row>

      <v-row
        class="mt-8"
        align="center"
        justify="center"
        dark>

        <v-btn
          color="grey"
          text
          >Legal Information
        </v-btn>

        <v-btn
          color="grey"
          text
        >Data Privacy
        </v-btn>

      </v-row>

    </v-container>
  </div>
</template>

<script>
import TextImageRow from '@/components/TextImageRow';
import StepperItem from '@/components/StepperItem';
import SignUpButton from '@/components/SignUpButton';
import ImageWithText from '@/components/ImageWithText';

import i18n from '@/i18n';

  export default {
    name: 'Landingpage',
    components: {
      TextImageRow,
      StepperItem,
      SignUpButton,
      ImageWithText
    },
    data: () => ({
      languages: [
        { flag: 'us', language: 'en', title: 'English' },
        { flag: 'it', language: 'it', title: 'Italiano' }
      ],
    }),
    methods: {
      changeLocale() {
        var userLang = navigator.language || navigator.userLanguage || 'it';
        i18n.locale = userLang.split('-')[0];
      }
    },
  }
</script>
